(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ventames', {
            parent: 'entity',
            url: '/ventames',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.ventames.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ventames/ventames.html',
                    controller: 'VentamesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ventames');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ventames-detail', {
            parent: 'ventames',
            url: '/ventames/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.ventames.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ventames/ventames-detail.html',
                    controller: 'VentamesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ventames');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Ventames', function($stateParams, Ventames) {
                    return Ventames.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ventames',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ventames-detail.edit', {
            parent: 'ventames-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventames/ventames-dialog.html',
                    controller: 'VentamesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ventames', function(Ventames) {
                            return Ventames.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ventames.new', {
            parent: 'ventames',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventames/ventames-dialog.html',
                    controller: 'VentamesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                anio: null,
                                mes: null,
                                diasventa: null,
                                cantcomercios: null,
                                cantpv: null,
                                monto: null,
                                tickets: null,
                                items: null,
                                filecsv: null,
                                mdepefectivomonto: null,
                                mdepefectivocantidad: null,
                                mdeptarjetasmonto: null,
                                mdeptarjetascantidad: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ventames', null, { reload: 'ventames' });
                }, function() {
                    $state.go('ventames');
                });
            }]
        })
        .state('ventames.edit', {
            parent: 'ventames',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventames/ventames-dialog.html',
                    controller: 'VentamesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ventames', function(Ventames) {
                            return Ventames.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ventames', null, { reload: 'ventames' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ventames.delete', {
            parent: 'ventames',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventames/ventames-delete-dialog.html',
                    controller: 'VentamesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Ventames', function(Ventames) {
                            return Ventames.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ventames', null, { reload: 'ventames' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
